import React, { memo } from 'react'
import memoize from 'memoize-one'
import AutoSizer from 'react-virtualized-auto-sizer'
import { FixedSizeList } from 'react-window'
import InfiniteLoader from 'react-window-infinite-loader'

import TracksItem from './TracksItem'

import styles from './app.module.css'

function TracksWrapper({
  hasNextPage,
  isNextPageLoading,
  items,
  loadNextPage,
  setPlayerTrack,
  playerTrack,
  selectionState,
  toggleSelection,
  filter,
  infiniteLoaderRef,
}) {
  const itemCount = hasNextPage ? items.length + 1 : items.length
  const loadMoreItems = isNextPageLoading ? () => {} : loadNextPage
  const isItemLoaded = (index) => !hasNextPage || index < items.length

  const itemData = createItemData(
    items,
    playerTrack,
    setPlayerTrack,
    selectionState,
    toggleSelection,
    filter,
    isItemLoaded
  )

  const memoFixedSizeListStyle = {
    overflow: 'auto',
    overscrollBehavior: 'contain',
  }

  return (
    <AutoSizer style={autoSizerStyle}>
      {({ height, width }) => (
        <InfiniteLoader
          isItemLoaded={isItemLoaded}
          itemCount={itemCount}
          loadMoreItems={loadMoreItems}
          ref={infiniteLoaderRef}
        >
          {({ onItemsRendered, ref }) => (
            <FixedSizeList
              height={height}
              className={styles.tracksPlayerList}
              itemCount={itemCount}
              itemSize={74}
              onItemsRendered={onItemsRendered}
              ref={ref}
              width={width}
              itemData={itemData}
              style={memoFixedSizeListStyle}
              overscanCount={7}
            >
              {TracksItem}
            </FixedSizeList>
          )}
        </InfiniteLoader>
      )}
    </AutoSizer>
  )
}

export default memo((props) => <TracksWrapper {...props} />)

const autoSizerStyle = { height: 'calc(100vh - 346px)' }

const createItemData = memoize(
  (
    items,
    playerTrack,
    setPlayerTrack,
    selectionState,
    toggleSelection,
    filter,
    isItemLoaded
  ) => ({
    items,
    playerTrack,
    setPlayerTrack,
    selectionState,
    toggleSelection,
    filter,
    isItemLoaded,
  })
)
